import React from 'react';

import { EllipsisTooltip } from '@/components/ui/EllipsisTooltip';
import { TableCell, TableRow } from '@/components/ui/table';
import { cn } from '@/utils/cn';
import { formatNumber } from 'utils';

import { HoldingRow } from '../../holdings';
import { EM_DASH, formatFullCurrency, formatFullPercent } from '../../reporting/format';
import { gainCell, MV_CELL, NUMERIC_CELL } from '../../reporting/table-styles';

// One holdings table row. The row model carries every per-tab difference: bonds bring
// secondaryText (the maturity date on a second line, like the client-portal bond table),
// cash balances bring null price/quantity (rendered as an em dash).
export const HoldingTableRow = ({ row }: { row: HoldingRow }) => (
    <TableRow>
        <TableCell className="text-cocoa-900 text-sm font-semibold">{row.symbol}</TableCell>
        <TableCell className="text-cocoa-900 max-w-xs text-sm">
            <EllipsisTooltip>{row.name}</EllipsisTooltip>
            {row.secondaryText && <div className="text-cocoa-400 text-xs">{row.secondaryText}</div>}
        </TableCell>
        <TableCell className="text-cocoa-500 text-sm">{row.assetClass}</TableCell>
        <TableCell className={cn(NUMERIC_CELL, 'text-cocoa-700')}>{formatFullPercent(row.weight)}</TableCell>
        <TableCell className={cn(NUMERIC_CELL, 'text-cocoa-900')}>
            {row.price === null ? EM_DASH : formatFullCurrency(row.price)}
        </TableCell>
        <TableCell className={cn(NUMERIC_CELL, 'text-cocoa-900')}>
            {row.quantity === null ? EM_DASH : formatNumber(row.quantity, 2)}
        </TableCell>
        <TableCell className={MV_CELL}>{formatFullCurrency(row.marketValue)}</TableCell>
        <TableCell className={gainCell(row.unrealizedGainLoss)}>{formatFullCurrency(row.unrealizedGainLoss)}</TableCell>
        <TableCell className={gainCell(row.returnPercent)}>{formatFullPercent(row.returnPercent)}</TableCell>
    </TableRow>
);
